
        import * as module0 from './styles/App.scss';import * as module1 from './styles/_root.scss'

        const modules = [module0,module1];

        export default modules;
        export const filenames = ['./styles/App.scss','./styles/_root.scss']
      